import React, { forwardRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { Body1, Body2, Dot } from "@activecollab/components";
import PropTypes from "prop-types";
import { CompanyNameContainer } from "~/components/Companies/CompanyNameContainer";
import ProjectName from "~/components/project/ProjectName";
import { makeGetUserAssignmentsCountSelector } from "~/store/selectors/selector.userTasks";

const MyWorkUserProjectItem = forwardRef(({ id, companyId }, ref) => {
  const getCountAssignments = useMemo(() => makeGetUserAssignmentsCountSelector(id), [id]);
  const countAssignments = useSelector(getCountAssignments);

  return (
    <div
      className="tw-flex tw-items-center tw-overflow-hidden tw-h-10"
      ref={ref}
    >
      <Body1
        color="secondary"
        weight="medium"
        className="tw-leading-6 tw-truncate tw-flex"
      >
        <span className="tw-truncate">
          <ProjectName id={id} />
        </span>
        <span className="tw-shrink-0">&nbsp;({countAssignments})</span>
      </Body1>
      <Dot
        className="tw-shrink-0 tw-mx-2"
        color="var(--color-theme-500)"
        size={4}
      />
      <Body2
        color="tertiary"
        className="tw-truncate tw-shrink-0"
      >
        <CompanyNameContainer id={companyId} />
      </Body2>
    </div>
  );
});

MyWorkUserProjectItem.propTypes = {
  id: PropTypes.number.isRequired,
  companyId: PropTypes.number.isRequired,
};

MyWorkUserProjectItem.displayName = "MyWorkUserProjectItem";

export default React.memo(MyWorkUserProjectItem);
